import { gql } from "@apollo/client";

export const GET_TOTAL_STUDENT_FOR_DASHBOARD = gql`
  query GetTotalStudentForDashboard(
    $academicYearId: ID
    $schoolId: ID
    $levelId: ID
    $groupId: ID
    $teacherId: ID
  ) {
    getTotalStudentForDashboard(
      academic_year_id: $academicYearId
      school_id: $schoolId
      level_id: $levelId
      group_id: $groupId
      teacher_id: $teacherId
    ) {
      totalStudent
      female
    }
  }
`;

export const GET_TOTAL_DROP_OUT = gql`
  query GetTotalStudentDropOutForDashboard(
    $academicYearId: ID
    $schoolId: ID
    $levelId: ID
    $groupId: ID
    $teacherId: ID
  ) {
    getTotalStudentDropOutForDashboard(
      academic_year_id: $academicYearId
      school_id: $schoolId
      level_id: $levelId
      group_id: $groupId
      teacher_id: $teacherId
    ) {
      totalStudent
      female
    }
  }
`;

export const GET_ACTIVE_STUDENT = gql`
  query GetTotalStudentActiveForDashboard(
    $academicYearId: ID
    $schoolId: ID
    $levelId: ID
    $groupId: ID
    $teacherId: ID
  ) {
    getTotalStudentActiveForDashboard(
      academic_year_id: $academicYearId
      school_id: $schoolId
      level_id: $levelId
      group_id: $groupId
      teacher_id: $teacherId
    ) {
      female
      totalStudent
    }
  }
`;

export const GET_CERTIFICATE_OFFER = gql`
  query GetTotalStudentCertificateOffer(
    $academicYearId: ID
    $schoolId: ID
    $levelId: ID
    $groupId: ID
    $teacherId: ID
  ) {
    getTotalStudentCertificateOffer(
      academic_year_id: $academicYearId
      school_id: $schoolId
      level_id: $levelId
      group_id: $groupId
      teacher_id: $teacherId
    ) {
      totalStudent
      female
    }
  }
`;

export const GET_ALL_ENROLLMENT_CHART = gql`
  query GetAllEnrollmentChart($academicYearId: ID) {
    getAllEnrollmentChart(academic_year_id: $academicYearId) {
      female
      schoolName
      totalStudent
      schoolNameEn
    }
  }
`;

export const GET_ALL_DROP_OUT_CHART = gql`
  query GetAllDropOutChart($academicYearId: ID) {
    getAllDropOutChart(academic_year_id: $academicYearId) {
      female
      schoolName
      schoolNameEn
      totalStudent
    }
  }
`;

export const GET_ALL_REMAIN_STUDENT_CHART = gql`
  query GetAllRemainStudentChart($academicYearId: ID) {
    getAllRemainStudentChart(academic_year_id: $academicYearId) {
      schoolName
      schoolNameEn
      totalStudent
      female
    }
  }
`;

export const GET_STUDENT_ENROLLMENT_SHOW_BY_LEVEL = gql`
query GetStudentEnrollmentChartShowByLevel($academicYearId: ID, $schoolId: ID) {
  getStudentEnrollmentChartShowByLevel(academic_year_id: $academicYearId, school_id: $schoolId) {
    female
    levelName
    totalStudent
  }
}`

export const GET_STUDENT_ENROLLMENT_SHOW_BY_GROUP = gql`
query GetStudentEnrollmentChartShowByGroup(
  $academicYearId: ID
  $schoolId: ID
  $levelId: ID
) {
  getStudentEnrollmentChartShowByGroup(
    academic_year_id: $academicYearId
    school_id: $schoolId
    level_id: $levelId
  ) {
    totalStudent
    groupName
    female
  }
}`

export const GET_STUDENT_ENROLLMENT_SHOW_BY_CLASSES = gql`
query GetStudentEnrollmentChartShowByClasses($academicYearId: ID, $schoolId: ID, $teacherId: ID) {
  getStudentEnrollmentChartShowByClasses(academic_year_id: $academicYearId, school_id: $schoolId, teacher_id: $teacherId) {
    female
    groupName
    levelName
    totalStudent
  }
}`

export const GET_STUDENT_DROP_OUT_SHOW_BY_LEVEL = gql`
query GetStudentDropOutChartShowByLevel($academicYearId: ID, $schoolId: ID) {
  getStudentDropOutChartShowByLevel(academic_year_id: $academicYearId, school_id: $schoolId) {
    female
    totalStudent
    levelName
  }
}`

export const GET_STUDENT_STUDENT_DROP_OUT_SHOW_BY_GROUP = gql`
query GetStudentDropOutChartShowByGroup($academicYearId: ID, $schoolId: ID, $levelId: ID) {
  getStudentDropOutChartShowByGroup(academic_year_id: $academicYearId, school_id: $schoolId, level_id: $levelId) {
    totalStudent
    female
    groupName
  }
}`

export const GET_STUDENT_DROP_OUT_SHOW_BY_CLASSES = gql`
query GetStudentDropOutChartShowByClasses($academicYearId: ID, $schoolId: ID, $teacherId: ID) {
  getStudentDropOutChartShowByClasses(academic_year_id: $academicYearId, school_id: $schoolId, teacher_id: $teacherId) {
    female
    totalStudent
    levelName
    groupName
  }
}`

export const GET_STUDENT_REMAIN_SHOW_BY_LEVEL = gql`
query GetStudentRemainChartShowByLevel($academicYearId: ID, $schoolId: ID) {
  getStudentRemainChartShowByLevel(academic_year_id: $academicYearId, school_id: $schoolId) {
    totalStudent
    female
    levelName
  }
}`

export const GET_STUDENT_REMAIN_SHOW_BY_GROUP = gql`
query GetStudentRemainChartShowByGroup($academicYearId: ID, $schoolId: ID, $levelId: ID) {
  getStudentRemainChartShowByGroup(academic_year_id: $academicYearId, school_id: $schoolId, level_id: $levelId) {
    totalStudent
    female
    groupName
  }
}`

export const GET_STUDENT_REMAIN_SHOW_BY_CLASSES = gql`
query GetStudentRemainChartShowByClasses($academicYearId: ID, $schoolId: ID, $teacherId: ID) {
  getStudentRemainChartShowByClasses(academic_year_id: $academicYearId, school_id: $schoolId, teacher_id: $teacherId) {
    levelName
    groupName
    totalStudent
    female
  }
}`

export const GET_NUMBER_OF_STUDENT_ATTENDANCE_PERCENTAGE_UNDER_80 = gql`
query Query($academicYearId: ID) {
  getNumberOfStudentAttendanceLessThan80Percentage(academic_year_id: $academicYearId)
}
`

export const GET_STUDENT_ATTENDANCE_PERCENTAGE = gql`
query GetStudentAttendancePercentage($academicYearId: ID, $schoolId: ID, $teacherId: ID, $levelId: ID) {
  getStudentAttendancePercentage(academic_year_id: $academicYearId, school_id: $schoolId, teacher_id: $teacherId, level_id: $levelId) {
    attendancePercentage
    full_name_kh
    full_name_latin
    gender
    group
    level
    student_id
    school_name_en
    school_name_kh
  }
}`

export const GET_ATTENDACE_RATE_SHOW_BY_SCHOOL = gql`
query GetAttendanceRateChartShowBySchool($academicYearId: ID) {
  getAttendanceRateChartShowBySchool(academic_year_id: $academicYearId) {
    labelNameEng
    labelNameKh
    percentage
  }
}`

export const GET_ATTENDANCE_RATE_BY_LEVEL = gql`
query GetAttendanceRateChartShowByLevel($academicYearId: ID, $schoolId: ID) {
  getAttendanceRateChartShowByLevel(academic_year_id: $academicYearId, school_id: $schoolId) {
    labelNameEng
    labelNameKh
    percentage
  }
}`

export const GET_ATTENDANCE_RATE_BY_GROUP = gql`
query GetAttendanceRateChartShowByGroup($academicYearId: ID, $schoolId: ID, $levelId: ID) {
  getAttendanceRateChartShowByGroup(academic_year_id: $academicYearId, school_id: $schoolId, level_id: $levelId) {
    labelNameEng
    labelNameKh
    percentage
  }
}`

export const GET_ATTENDANCE_RATE_SHOW_BY_CLASSES = gql`
query GetAttendanceRateChartShowByClasses($academicYearId: ID, $schoolId: ID, $teacherId: ID) {
  getAttendanceRateChartShowByClasses(academic_year_id: $academicYearId, school_id: $schoolId, teacher_id: $teacherId) {
    labelNameEng
    labelNameKh
    percentage
  }
}`

export const GET_OVERALL_ATT_RATE = gql`
query Query($academicYearId: ID, $schoolId: ID, $levelId: ID, $groupId: ID, $teacherId: ID, $startDate: String, $endDate: String) {
  getAttendanceRate(academic_year_id: $academicYearId, school_id: $schoolId, level_id: $levelId, group_id: $groupId, teacher_id: $teacherId, start_date: $startDate, end_date: $endDate)
}`